// CommonSlogan.jsx

import React from 'react';

export default function CommonSlogan() {
  return (
    <div className="text-center text-3xl md:text-5xl font-bold tracking-widest py-8 text-white uppercase">
      TRUST.  NETWORK.  BUILD.
    </div>
  );
}
